const fileText = (files) => {
  const isSingle = files.length === 1;

  return `${ files.length }  file${ isSingle ? '' : 's' }`;
};

export default fileText;
